import React from "react";
import { useState } from "react";
import axios from "axios";
import SwitchBox  from "./SwitchBox";



const SearchFilter = ({ startYear, setStartYear, endYear, setEndYear, showAlert, setListInfo, setAlert, listInfo, 
  isOnDescription, setIsOnDecription, isTranslateAll, setIsTranslateAll}) => {

  const [text, setText] = useState("");
  const [listKey, setListKey] = useState("");
  const [listApp, setListApp] = useState([]);


  const handleClear = () => {
    setListInfo([]); 
    setListApp([]);
    setText("");
    setListKey("");
  };

   const years = Array.from({ length: 15 }, (_, i) => new Date().getFullYear() - i); 

  const handleSend = async () => {
    if (!text.trim()) return alert("Vui lòng nhập nội dung!");
    setListKey((prev) => (prev ? `${prev}, ${text}` : text));
    setText(""); // Xóa input sau khi tìm
    showAlert(`Đang tìm kiếm với từ khóa:` + text, "success");
    const apps = await fetchGooglePlayApps(text);
    setListApp(apps);
    showAlert(`📊 Tìm thấy ${apps.length} ứng dụng. Bắt đầu lấy dữ liệu...`);

    await Promise.all(
      apps.map(async (app, index) => {
        const proxyUrl = "https://sensor-proxy.sensorproxy-dev.workers.dev";
        const apiUrl = `https://app.sensortower.com/api/android/apps/${app.app_id}`;
        try {
          console.log(`📥 [${index}] Lấy dữ liệu: ${app.app_id}`);
          const response = await axios.get(`${proxyUrl}?url=${encodeURIComponent(apiUrl)}`);
          const details = response.data; // Dữ liệu chi tiết từ Sensor Tower

          const dateRealse = new Date(details.release_date); 
          const release_date = dateRealse.toLocaleDateString("vi-VN");

          const dateUpdate = new Date(details.recent_release_date);
          const update_date = dateUpdate.toLocaleDateString("vi-VN");  

          const description = details.description.app_summary;

          let text = description.match(/(<\s*)?\$(\d+\.?\d*[kKmM]?)(?: revenue)/);
          if (text == null) text = ["<$5K"];
          const revenue = text[0].replace(/\s*revenue/i, "");
          const download = description.match(/(<\s*)?(\d+[kKmM]?)(?=\s*downloads)/i);

          const link = "https://play.google.com/store/apps/details?id=" + details.app_id;
          const linkSensor = "https://app.sensortower.com/overview/" + details.app_id;
          const linkAppBrain = "https://www.appbrain.com/app/awallet-cloud-password-manager/" + details.app_id;

          const resultArray = {
            icon_url: details.icon_url,
            name : details.name,
            app_id:  details.app_id,
            release_date : release_date,
            update_date: update_date,
            installs:  details.installs,
            revenue: revenue != null ? revenue : "< $5k",
            download: download != null ? download[0] : "< 5k",
            link: link,
            linkSensor : linkSensor,
            linkAppBrain : linkAppBrain,
          };
          setListInfo(prevList => [...prevList, resultArray]);
          setListApp((prevList) => prevList.filter((app) => app.app_id !== details.app_id));

          await fetchDetailsAppFromGoogle(details.app_id);
          await fetchComment(details.app_id);
          } catch (error) {
            console.error(`❌ Lỗi khi lấy dữ liệu cho ${app.app_id}:`, error);
          }
        }
      )
    );
    showAlert(`🎉 Hoàn thành!`);
    setAlert(false);
  };

  async function fetchComment(keyword) {
    try {
      const response = await fetch(`https://toolcraw-qecjoikqn-toolcraw.vercel.app/comments?appId=${keyword}`, {
        headers: {
            "Content-Type": "text/html",
            "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36",
            "Authorization": "Bearer vhnQNfy0mnm4V89I6qqr4G3I"
        }
      });
      const data = await response.json();
      const filteredData = data.map(({ date, score, text }) => ({
        date: new Date(date).toLocaleDateString("vi-VN"), // Chuyển đổi sang dd/mm/yyyy
        score,
        text
      }));
       
  
      const lowToFourStars = filteredData.filter(comment => comment.score >= 1 && comment.score <= 4);
      const fiveStars = filteredData.filter(comment => comment.score === 5);
  
      setListInfo(prev =>
        prev.map(app =>
          app.app_id === keyword
            ? { ...app, lowToFourStars : lowToFourStars, fiveStars : fiveStars}
            : app           
        )
      )
    }catch (error){
      console.log(error);
    }
    
  }


  async function fetchGooglePlayApps(keyword) {
    const proxyUrl = "https://sensor-proxy.sensorproxy-dev.workers.dev/?url=";
    const targetUrl = `https://play.google.com/store/search?q=${encodeURIComponent(keyword)}&c=apps`;
  
    try {
      const fullUrl = proxyUrl + encodeURIComponent(targetUrl);
  
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36"
        }
      });
  
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      // Trích xuất danh sách ứng dụng
      const apps = [];
      const appElements = doc.querySelectorAll("div.VfPpkd-aGsRMb");  
      appElements.forEach((app) => {
        const name = app.querySelector("span")?.innerText || "N/A";
        const linkElement = app.querySelector("a");
        const appId = linkElement ? new URL(linkElement.href).searchParams.get("id") : "N/A";
        const icon = app.querySelector("img")?.src || ""; 
        if (!listInfo.some((existingApp) => existingApp.app_id === appId)) {
          apps.push({ name, app_id: appId, icon });
        }
      });
      return apps;
    } catch (error) {
      console.error("Error fetching apps:", error);
      return [];
    }
  }

  async function fetchDetailsAppFromGoogle(keyword) {
    const proxyUrl = "https://sensor-proxy.sensorproxy-dev.workers.dev/?url=";
    const targetUrl = `https://play.google.com/store/apps/details?id=${encodeURIComponent(keyword)}`;


    try {
        const fullUrl = proxyUrl + encodeURIComponent(targetUrl);
        const response = await fetch(fullUrl, {
            method: "GET",
            headers: {
                "Content-Type": "text/html",
                "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36"
            }
        });

        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
      
        // Lấy mô tả ứng dụng
        const descriptionElement = doc.querySelector('.bARER[data-g-id="description"]');
        const description = descriptionElement ? descriptionElement.innerHTML.trim() : "Không tìm thấy mô tả";


        // Lấy tất cả ảnh trong class .Atcj9b
      const images = Array.from(doc.querySelectorAll('.Atcj9b img')).map(img => ({
          src: img.src,
      }));
      
      // Lọc ra những ảnh có width < 200px
      let filteredImages = await filterSmallImages(images);

      if (filteredImages.length === 0) {
        filteredImages = images.slice(0, 8);
      } else if (filteredImages.length >= 8)  {
          filteredImages = filteredImages.slice(0, 8);
      }
      
      // Trả về kết quả
      const appDetails = { description, images: filteredImages };

      setListInfo(prev =>
        prev.map(app =>
          app.app_id === keyword
            ? { ...app, description: appDetails.description, screenshots: appDetails.images }
            : app           
        )
      );

    } catch (error) {
        console.error("Error fetching app details:", error);
        return { title: "", description: "", images: [] };
    }
  }

  async function filterSmallImages(images) {
    const filteredImages = [];

    for (const img of images) {
        await new Promise((resolve) => {
              const image = new Image();
              image.src = img.src;
              image.onload = () => {
                  if (image.naturalWidth < 200) {
                      filteredImages.push(img);
                  }
                  resolve();
              };
          });
      }
      return filteredImages;
  }
    
  return (
    <div className="p-6 space-y-4 bg-white rounded-lg w-full max-w-2xl mx-auto">
      {/* Input Keyword */}
      <div className="flex items-center space-x-4">
        <h2 className="text-xl font-semibold text-gray-800">Nhập keyword:</h2>
        <div className="relative w-96">
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Nhập gì đó..."
            className="w-full p-3 text-lg border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-4 focus:ring-blue-300 transition-all"
          />
          {/* Nút gửi */}
          <button
            onClick={handleSend}
            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-blue-500 text-white px-4 py-2 rounded-full shadow-md hover:bg-blue-600 transition-all"
          >
            Gửi
          </button>
        </div>
      </div>

      {/* Hiển thị kết quả nhập */}
      <p className="text-lg text-gray-700">
        Bạn đã nhập: <span className="font-semibold text-blue-600">{listKey}</span>
      </p>

      {/* Các nút điều khiển */}
      <div className="flex gap-4">
        {/* Nút Clear */}
        <button
          onClick={handleClear}
          className="px-4 py-2 bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 transition-all"
        >
          Clear
        </button>

        {/* Form tìm kiếm theo năm */}
        <div className="flex gap-4">
          {/* Dropdown chọn năm bắt đầu */}
          <select
            value={startYear}
            onChange={(e) => setStartYear(e.target.value)}
            className="w-32 p-2 border border-gray-300 rounded-lg text-center focus:ring-2 focus:ring-blue-300 focus:outline-none"
          >
            <option value="">Từ năm</option>
            {years.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>

          {/* Dropdown chọn năm kết thúc */}
          <select
            value={endYear}
            onChange={(e) => setEndYear(e.target.value)}
            className="w-32 p-2 border border-gray-300 rounded-lg text-center focus:ring-2 focus:ring-blue-300 focus:outline-none"
          >
            <option value="">Đến năm</option>
            {years.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        <div className="flex flex-col items-center">
          <SwitchBox checked={isOnDescription} onChange={() => setIsOnDecription(!isOnDescription)} />
          <p>Mô tả: {isOnDescription ? "Bật" : "Tắt"}</p>
        </div>
          
        <div className="flex flex-col items-center">
          <SwitchBox checked={isTranslateAll} onChange={() => setIsTranslateAll(!isTranslateAll)} />
          <p>Dịch: {isTranslateAll ? "Bật" : "Tắt"}</p>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
